<mat-checkbox style="margin-left:16px"
    color="primary" [(ngModel)]="defectsOnly" (change)="toggleDefectsOnly($event)">
    {{ '@defectsOnly' | translate }}
</mat-checkbox>
<app-dynamic-table title="{{'@dvir'}}" [searchString]="searchString" [functions]="tableFunctions" (functionCallback)="processFunction($event)" [includeSelect]="includeSelect" pathName="/fleet/dvir" [dataSource]="dataSource"
    [gridDisplayColumns]="gridDisplayColumns" [length]="length" [loading]="loading" [baseSortString]="baseSort">
</app-dynamic-table>

<ng-template #isFalseCleanTemplate let-data="data">
    <div title="" class="falseCleanContainer" *ngIf="data.isFalseClean">
        <mat-icon color="warn" [matTooltip]="data.reason">flag</mat-icon>
    </div>
</ng-template>